module.exports = __webpack_public_path__ + "static/media/form-bg.e6f50346.png";